// extracted by mini-css-extract-plugin
export default {"oscillator":"Oscillator_oscillator__xR6Yt","oscSelector":"Oscillator_oscSelector__zuyGl"};